import { createContext } from 'react';

import useWhatsApps from '../../hooks/useWhatsApps/index.jsx';

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const { loading, whatsApps, updateSession, fetchWhatsApps } = useWhatsApps();

  return (
    <WhatsAppsContext.Provider value={{ whatsApps, loading, updateSession, fetchWhatsApps }}>
      {children}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };
